export default __webpack_public_path__ + "slices/main/assets/public/media/community-carousel-slide-2.2148eed9c92a3b98955fe69dae7b7b13.png";